import http from '../components/http';
import { IProcesso } from '../interfaces/processo.interface';

// Função para buscar todos os pedidos
export const fetchProcessos = async (): Promise<IProcesso[]> => {
  const response = await http.get('/processos');
  return response.data;
};

// Função para criar um novo pedido
export const createProcesso = async (processo: IProcesso): Promise<IProcesso> => {
  let response;
  try {
    response = await http.post('/processos', processo);
  } catch (error) {
    console.log(error);
  }
  
  return response?.data;
};

// Função para atualizar um processo existente
export const updateProcesso = async (id: string, processo: IProcesso): Promise<IProcesso> => {
  const response = await http.put(`/processos/${id}`, processo);
  return response.data;
};

// Função para deletar um processo
export const deleteProcesso = async (id: string): Promise<void> => {
  await http.delete(`/processos/${id}`);
};
